import React from 'react';
import InputField from 'components/InputField/InputField';
import FileField from 'components/InputField/FileField'
import Select from 'react-select';
import RoleTagSelect from 'containers/Input/DisciplineRoles';


const labels = {
  title: 'Title'

}

const NewDisciplineForm = ({
                             discipline = {},
                             errors = {},
                             onFieldChange,
                             onSubmit,
                             onRoleDisciplineChange,
                             rolesOptions

                           }) => {
  return (
    <div className="container_records">
      <div className="add_webinar new-webinar">
        <h3>Add discipline</h3>
        <div className="add_webinar_bg row">
          <form className="col s12">
            {
              [
                'title'
              ].map(e => (
                <InputField
                  className='col s12'
                  label={labels[e]}
                  field_name={e}
                  onChange={onFieldChange}
                  errors={errors[e]}
                  autoComplete='new-password'
                  value={discipline[e]}
                />
              ))
            }
            <div>
              <div className="col s12">
                <RoleTagSelect
                  style={{marginTop: 10}}
                  options={rolesOptions}
                  placeholder='Select roles'
                  value={discipline.discipline_type}
                  onChange={onRoleDisciplineChange}
                  multi={true}
                />

                <a className={`${!discipline.discipline_type && 'hide'}`}
                   href="javascript:void(0)"
                   onClick={() => {
                     onFieldChange({target: {name: 'discipline_type', value: []}})
                   }}
                >
                  Clear
                </a>
              </div>
            </div>
            <button onClick={onSubmit} className="button_classic" type="button" name="button"> Save</button>
          </form>
        </div>
      </div>
    </div>
  );
}

NewDisciplineForm.defaultProps = {};
export default NewDisciplineForm;



// WEBPACK FOOTER //
// ./src/components/Admin/Discipline/NewDisciplineForm.jsx